/** Suspense fallback shown while a lazy-loaded screen chunk is fetching.
 *  Keeps Topbar layout stable so the page does not jump on chunk arrival. */
export function ScreenLoader({ label }: { label?: string } = {}) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '40px 20px',
        gap: 14,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          border: '3px solid var(--surface-2)',
          borderTopColor: 'var(--accent)',
          animation: 'screen-loader-spin 0.9s linear infinite',
        }}
      />
      <span
        style={{
          fontFamily: 'Space Mono, monospace',
          fontSize: 11,
          textTransform: 'uppercase',
          letterSpacing: 1,
          fontWeight: 700,
          color: 'var(--ink-mute)',
        }}
      >
        {label ?? 'Загрузка…'}
      </span>
      <style>
        {`@keyframes screen-loader-spin { to { transform: rotate(360deg); } }
          @media (prefers-reduced-motion: reduce) {
            [aria-hidden="true"] { animation: none !important; }
          }`}
      </style>
    </div>
  );
}
